import progress from '../utils/progress';

let formIsBeingSubmitted = false;

/* eslint-disable import/prefer-default-export */
/**
 *  Initializes the privacy `accept` event listener.
 */
export const init = () => {
    document.addEventListener('click', e => {
        const {target} = e;
        if (target.matches('#privacy-policy-save')) {
            e.preventDefault();
            if (!formIsBeingSubmitted) {
                progress.show(target);
                formIsBeingSubmitted = true;
                $.ajax({
                    type: 'POST',
                    dataType: 'json',
                    url: target.dataset.url,
                    /**
                     * Asynchronous request success state
                     *
                     * @param {Object} response - response
                     */
                    success: response => {
                        formIsBeingSubmitted = false;
                        const cardParent = document.getElementById('privacy-policy-card').parentElement;
                        cardParent.innerHTML = response.msg;
                        const message = cardParent.querySelector('.message');
                        if (message) {
                            cardParent.querySelector('.message').classList.add('message-card');
                        }
                        progress.hide();
                    },
                    /**
                     * Asynchronous request error state
                     */
                    error: () => {
                        formIsBeingSubmitted = false;
                        progress.hide();
                    }
                });
            }
        }
    });
};
